import { render, staticRenderFns } from "./EditorImagesModal.vue?vue&type=template&id=5d8b612e&"
import script from "./EditorImagesModal.vue?vue&type=script&lang=js&"
export * from "./EditorImagesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports